import DialogComponent from "../../../components/DialogComponent";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { deleteItem, updateItem } from "src/modules/spItems/actions";
import Trash from "src/components/ui-icons/buttons/Trash";
import Button from "src/components/Button";
import { documentByCardFilesLibName } from "src/api/config";
import { myTaskActionCommentsFilesListName } from "src/api/config/myTasksActions.config";

type Props = {
    open: boolean;
    dialogToggle: any;
    removeData: any;
    setOpen: any;
}

const ConfirmRemoveModal = (props: Props) => {

    const { open, dialogToggle, removeData, setOpen } = props
    const dispatch = useAppDispatch();

    const removeHandle = (params: any) => {
        if (params.listName === documentByCardFilesLibName || params.listName === myTaskActionCommentsFilesListName) {
            dispatch(updateItem({ listName: params.listName, body: { ID: params.ID, ForHistory: true } }));
        } else {
            dispatch(deleteItem(params));
        }
    }

    return (
        <DialogComponent open={open} toggleDialog={dialogToggle}>
            <div className="removeElement">
                <span className="block text-[24px] mb-[18px] leading-7.5 font-semibold">Подтвердите действие</span>
                <span className="block text-[16px] leading-[22px] mb-[38px]">Вы&nbsp;уверены, что хотите удалить?<br />Действие не обратимо</span>
                <div className="divide-y mb-[40px] h-px border-t" />
                <div className="flex justify-between">
                    <div className="mr-5">
                        <Button
                            classBg="btn-white"
                            shadow={true}
                            text="Удалить"
                            customFunction={removeHandle}
                            paramsCustomFunction={removeData}
                            open={open}
                            setOpen={setOpen}
                            icon={true}
                            typeIcon="remove"
                        />
                    </div>
                    <div className="ml-5">
                        <Button
                            open={open}
                            setOpen={setOpen}
                            classBg="btn-dark"
                            text="Вернуться к документу"
                        />
                    </div>
                </div>
            </div>
        </DialogComponent>
    );
};

export default ConfirmRemoveModal;
